import { Grid, Group, type MantineBreakpoint, Paper, Stack, type StyleProp, Text, rem } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';
import classes from './VipClub.module.css';
export type VipClubDetailItemProps = {
  title: string;
  isLeftRadius?: boolean;
  isRightRadius?: boolean;
  justify: React.CSSProperties['justifyContent'];
  description?: string;
  status?: React.ReactNode;
  visibleForm?: MantineBreakpoint;
  w?: StyleProp<React.CSSProperties['width']>;
};
export const VipClubDetailItem: React.FC<VipClubDetailItemProps> = ({
  title,
  justify,
  isLeftRadius,
  isRightRadius,
  description,
  status,
  visibleForm,
  w
}) => {
  return <Grid.Col span={{
    base: 2.4,
    sm: 1.3,
    lg: 1.2
  }} visibleFrom={visibleForm}>
      <Stack gap={8} mb={{
      base: 20,
      sm: 0
    }}>
        <Group justify="center" h={37}>
          <Text w={w} fw={700} mt="auto" ta="center" tt="uppercase" fz={{
          base: 9,
          lg: 12
        }} style={{
          wordBreak: 'break-word'
        }}>
            {title}
          </Text>
        </Group>
        <Paper p={20} radius={0} bg="var(--bg-300)" className={isLeftRadius ? classes.radiusLeft : isRightRadius ? classes.radiusRight : ''}>
          <Group justify={justify} align="center" h="100%">
            {description ? <Text maw={50} fz="xs" ta="center" tt="uppercase" truncate="end" fw={700} lh={rem(16)}>
                {description}
              </Text> : status ? <IconCheck size={16} /> : <IconX size={16} />}
          </Group>
        </Paper>
      </Stack>
    </Grid.Col>;
};